import SplunkOtelWeb, { SessionBasedSampler } from "@splunk/otel-web";

const splunkRumToken = import.meta.env.VITE_SPLUNK_RUM_TOKEN;
const env = import.meta.env.VITE_ENV;

if (env !== "local") {
  SplunkOtelWeb.init({
    realm: "us1",
    rumAccessToken: splunkRumToken,
    applicationName: `WJ_Digital_Information_Solutions_OWFSA_${env}`,
    deploymentEnvironment: `WJ_Digital_Information_Solutions_${env}`,
    tracer: {
      sampler: new SessionBasedSampler({
        ratio: 0.2,
      }),
    },
  });
}